import { render } from "./paga-payment.vue?vue&type=template&id=e29004d6"
import script from "./paga-payment.vue?vue&type=script&lang=js"
export * from "./paga-payment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__